import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Alert, Input } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import logo from './img/logo_netline_190x70.png';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [onLogin, setOnLogin] = useState(false);

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    changeDefaultLocale('es');
    setShowForm(true);
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true);
    setError({
      open: false,
      message: "",
    });

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false);
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage");
        if (_translate) message = _translate;
        else if (error.details) message = error.details;
        setOnLogin(false);
        setError({ open: true, message: message });
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="netline-wrapper" ref={nodeRef}>
        <div className="netline-card">
          <div className="netline-logo-container">
            <img src={logo} alt="Netline" className="netline-logo" />
          </div>

          <h1 className="netline-title">Iniciar sesión</h1>
          <p className="netline-subtitle">Accede con tu cuenta de afiliado</p>
          <div className="netline-accent"></div>

          <Form className="netline-form" onSubmit={(event) => onSubmit(event)}>
            <div className="netline-field">
              <label className="netline-label" htmlFor="username">{translate("LabelUserName")}</label>
              <Input
                className="netline-input"
                disabled={onLogin}
                required={true}
                tabIndex={1}
                type="text"
                autoCorrect="off"
                autoCapitalize="none"
                id="username"
                onChange={e => setUsername(e.target.value)}
                placeholder={translate("PlaceholderUserName")}
              />
            </div>

            <div className="netline-field">
              <label className="netline-label" htmlFor="password">{translate("LabelPassword")}</label>
              <Input
                className="netline-input"
                required={true}
                disabled={onLogin}
                tabIndex={1}
                type="password"
                autoCorrect="off"
                autoCapitalize="none"
                id="password"
                placeholder={translate("PlaceholderPassword")}
                onChange={e => setPassword(e.target.value)}
              />
            </div>

            <div className="netline-turnstile">
              <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
            </div>

            <button
              tabIndex={1}
              type="submit"
              className="netline-btn"
              disabled={!props.turnstileSuccess || onLogin}
            >
              {translate("ButtonEnter")}
            </button>
          </Form>

          <Alert
            color="danger"
            className="netline-alert"
            isOpen={error.open}
            toggle={() => setError({ open: false })}
          >
            {error.message}
          </Alert>

          <p className="netline-footer">Netline · Acceso seguro</p>
        </div>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true });